import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_text",
  "use": "svg_text-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 18\" id=\"svg_text\"><path d=\"m12.638 4.908-7.01 7.01H3V9.29l7.01-7.01 2.628 2.628Zm2.075-2.074L13.34 4.208l-2.628-2.63L12.084.206a.698.698 0 0 1 .989 0l1.64 1.64a.698.698 0 0 1 0 .989ZM0 16h16v2H0v-2Z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol